<div>
  <ngx-spinner type="ball-circus"></ngx-spinner>
  <router-outlet></router-outlet>
</div>
